import React, { cloneElement, isValidElement } from 'react';
import { ButtonData } from '../../../components/buttonGroup/MultiSelectButtonGroup';
import './MapFilterOverlay.css';

interface MapFilterOverlayProps {
    scopes?: ButtonData[];
    activeScope: string[];
    onToggle: (key: string) => void;
}

const KEY_COLOR_VAR: { [key: string]: string } = {
    after_school: 'var(--bs-sfc-pink)',
    camps: 'var(--bs-sfc-orange)',
    events: 'var(--bs-sfc-green)'
};

const MapFilterOverlay: React.FC<MapFilterOverlayProps> = ({
                                                               scopes,
                                                               activeScope,
                                                               onToggle
                                                           }) => {
    if (!scopes || scopes.length === 0) return null;

    const toggleableScopes = scopes.filter((s) => s.key && KEY_COLOR_VAR[s.key]);

    const selectedScopes = toggleableScopes.filter(
        (s) => s.key && activeScope.includes(s.key)
    );

    const allSelected = selectedScopes.length === toggleableScopes.length;
    const noneSelected = selectedScopes.length === 0;

    const renderLegend = () => {
        if (noneSelected || allSelected) {
            return <span className="map-filter-overlay__legend-text">All</span>;
        }
        return (
            <span className="map-filter-overlay__legend-text">
        {selectedScopes.map((s, idx) => (
            <React.Fragment key={s.key}>
                <span style={{ color: KEY_COLOR_VAR[s.key!] }}>{s.title}</span>
                {idx < selectedScopes.length - 1 && (
                    <span className="map-filter-overlay__legend-sep"> & </span>
                )}
            </React.Fragment>
        ))}
      </span>
        );
    };

    return (
        <div className="map-filter-overlay">
            <div className="map-filter-overlay__icons">
                {toggleableScopes.map((scope) => {
                    const isActive = scope.key ? activeScope.includes(scope.key) : false;
                    return (
                        <button
                            key={scope.key}
                            type="button"
                            className={`map-filter-overlay__icon ${isActive ? 'is-active' : ''}`}
                            onClick={() => scope.key && onToggle(scope.key)}
                            aria-label={scope.title}
                            title={scope.title}
                        >
                            {scope.icon}
                        </button>
                    );
                })}
            </div>
            <div className="map-filter-overlay__divider" />
            <div className="map-filter-overlay__legend">{renderLegend()}</div>
        </div>
    );
};

export default MapFilterOverlay;